import React from 'react'
import configureStore from '../../shared/configure_store'
import members from '../reducers/dashboard/members_index'
import { GlobalProvider } from '../../shared/global_context'
import GgGolfHubEventRosterComponent from './gg_golf_hub_event_roster_component'

const GgGolfHubEventRosterRoot = (initialState) => {
  const state = {
    showMembers: false,
    members: [],
    entryFees: 0,
    totalMembers: 0,
    leagueId: initialState.leagueId,
    customerId: initialState.customerId,
    customerCountry: initialState.customerCountry,
    leagueName: initialState.leagueName,
    paths: initialState.paths,
    loadedMembersCount: 0,
    editMember: {},
  }
  const store = configureStore(members, state)

  return (
    <GlobalProvider store={store}>
      <GgGolfHubEventRosterComponent/>
    </GlobalProvider>
  )
}

export default GgGolfHubEventRosterRoot
